<template>
    <div class="carBox">
        <el-card ref="right_content" class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>项目名称：</label>
                        <el-input v-model="search_Obj.f_orgname" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="orgname" label="项目名称" sortable="custom"></el-table-column>
                        <el-table-column prop="code" label="编码" sortable="custom"></el-table-column>
                        <el-table-column prop="pxorder" label="顺序" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <List
                    width="1000px"
                    :org_id="model_id"
                    title="分配角色"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </List>
            </div>
        </el-card>
    </div>
</template>
<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import listutil from "@/libs/listutil";
import { getListData } from '@/api/common'
import List from "./list";

export default {
    name: "orgRoleList",
    mixins: [listutil],
    components: {Btns, LabBtns, List},
    data(){
        return {
            m_name: '分配角色',
            menu_id: 1220,
            pid: 0,
            orgData: [],
            list_url: "/api/admin/org/list",
            search_Obj: {
                f_orgname: '',
                f_pid: '0',
            },
            del_Obj:{
                url:'/api/admin/org/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            sortData: {
                prop: 'pxorder',
                order: 'ascending'
            },
            pid: 0,
            parents: [],
            treeData: [],
        }
    },
    methods: {
        getListData() {
            this.loading = true;
            this.selectData = [];
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.parents = res.data.parents;
                    this.treeData = res.data.treeData;
                }
            })
        },
        allocation(index, row){
            this.model_id = row.id
            this.infoshow = true
        },
    }
}
</script>